export const staticMenuSeed = [
  { name: "Dashboard", route_path: "/dashboard" },
  {
    name: "Employee Management",
    route_path: "/employee-management",
    children: [
      { name: "Staff List", route_path: "/hr/employee-management/stafflist" },
      { name: "Employee List", route_path: "/hr/employee-management/employeelist" },
      { name: "Staff Profile", route_path: "/hr/employees/profile" },
      { name: "Add / Edit Staff", route_path: "/hr/employee-management/add-edit" },
    ],
  },
  {
    name: "Variations",
    route_path: "/variations/initiate",
    children: [
      { name: "Initiate Variation", route_path: "/variations/initiate" },
      { name: "Pending Review", route_path: "/variations/review/pending" },
      { name: "Variation Loaders", route_path: "/variations/loaders" },
      { name: "Variation Batches", route_path: "/variations/batches" },
      { name: "Variation Reports", route_path: "/variations/reports" },
      { name: "Temporary Stoppage", route_path: "/variations/temporarystoppage" },
    ],
  },
  {
    name: "Payroll",
    route_path: "/payroll",
    children: [
      { name: "Payroll Run", route_path: "/payroll/run" },
      { name: "Payroll Preview", route_path: "/payroll/preview" },
      { name: "Payroll Approval", route_path: "/payroll/approval" },
      { name: "Payroll History", route_path: "/payroll/history" },
      { name: "Exit Due Review", route_path: "/payroll/exit-due-review" },
    ],
  },
  {
    name: "Setup",
    route_path: "/setup",
    children: [
      { name: "Pay Items", route_path: "/setup/pay-items" },
      { name: "Grade Levels", route_path: "/setup/grade-levels" },
      { name: "Cadres", route_path: "/setup/cadres" },
      { name: "Designations", route_path: "/setup/designations" },
      { name: "Salary Structures", route_path: "/setup/salary-structures" },
      { name: "Earnings", route_path: "/setup/earnings" },
      { name: "Deductions", route_path: "/setup/deductions" },
      { name: "Map Salary Structures", route_path: "/setup/map-salary-structure" },
      { name: "Irregular Allowances", route_path: "/setup/irregularallowances" },
      { name: "Staff Categories", route_path: "/setup/staff-categories" },
    ],
  },
  {
    name: "Reports",
    route_path: "/reports/management",
    children: [
      { name: "Management Reports", route_path: "/reports/management" },
      { name: "Payroll Summary", route_path: "/reports/payment/summary" },
      { name: "Tax Reports", route_path: "/reports/statutory/tax" },
      { name: "Pension Reports", route_path: "/reports/statutory/pension" },
      { name: "Nominal Roll", route_path: "/reports/nominal-roll" },
    ],
  },
  {
    name: "Settings",
    route_path: "/settings/organization",
    children: [
      { name: "Organization Setup", route_path: "/settings/organization" },
      { name: "Payroll Config", route_path: "/settings/payroll-config" },
      { name: "Tax Regimes", route_path: "/settings/tax-regimes" },
      { name: "Tax Policies", route_path: "/settings/tax-policies" },
      { name: "Users", route_path: "/settings/users" },
      { name: "Security Logs", route_path: "/settings/security" },
    ],
  },
  {
    name: "Organization Setup",
    children: [
      {
        name: "Organization Profile",
        route_path: "/organization-setup/company-profile",
      },
      {
        name: "Branches / Campuses",
        route_path: "/organization-setup/branches",
      },
      {
        name: "Departments",
        route_path: "/organization-setup/departments",
      },
    ],
  },
  {
    name: "Support",
    route_path: "/support/faqs",
    children: [
      { name: "FAQs", route_path: "/support/faqs" },
      { name: "Contact Support", route_path: "/support/contact" },
    ],
  },
];
